import * as z from "zod";

// The formats the entities of the party domain share: a field is written once, for the forms, the gateway and the
// worker.

export { emailAddress } from "../email-address";

/** Trimmed, never empty: an empty field is `null`. */
export const shortText = (max: number) => z.string().trim().min(1).max(max);

/** ISO 3166-1 alpha-2, as `reference.country.code`. */
export const countryCode = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z]{2}$/);

/** ISO 4217, as `reference.currency.code`. */
export const currencyCode = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z]{3}$/);

export const organizationRef = z.object({ id: z.uuid(), name: z.string() });
